import { call, select, takeEvery, takeLeading } from 'redux-saga/effects';

import { authSelectors } from '../auth';
import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as entitlementsActions from './entitlementsActions';
import * as entitlementsTypes from './entitlementsTypes';

const mkResourceConfig = (props) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'entitlements',
    resourceBaseUrl: '/entitlements',
    axiosConfig: { headers: { 'qcs-dataset-id': null } },
    transformResponseToResources: (response) =>
      response.data.entitlements.map((data) => entitlementsTypes.mkEntitlement(data)),
    ...props,
  });

export function* getEntitlements(config, action) {
  const datasetId = yield select(authSelectors.getDatasetId);
  const getConfig = config.set('resourceBaseUrl', datasetId ? `/datasets/${datasetId}/entitlements` : '/entitlements');
  yield call(resourceSagaUtils.qcsSyncGetResources, getConfig, action);
}

export function* getEntitlementsActionWatcher() {
  const resourceConfig = mkResourceConfig({
    resourceBaseUrl: '/entitlements',
    successAction: entitlementsActions.getEntitlementsSuccess,
    failureAction: entitlementsActions.getEntitlementsFailure,
  });
  yield takeLeading(entitlementsActions.getEntitlements, getEntitlements, resourceConfig);
}

export function* createEntitlementActionWatcher() {
  const config = mkResourceConfig({
    transformResourceWithResponse: (resource, response) =>
      response.data.entitlements.map((data) => entitlementsTypes.mkEntitlement(data)),
    successAction: entitlementsActions.createEntitlementSuccess,
    failureAction: entitlementsActions.createEntitlementFailure,
  });
  yield takeEvery(entitlementsActions.createEntitlement, resourceSagaUtils.qcsSyncCreateResource, config);
}

export default [getEntitlementsActionWatcher, createEntitlementActionWatcher];
